import { useMemo } from 'react';
import { EgressFilteringService } from '@forge/egress';
export var useEgressPermissionService = function useEgressPermissionService(permissionType, egress) {
  return useMemo(function () {
    var egressUrls = (egress || []).find(function (permission) {
      return permission.type === permissionType;
    });
    var allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new EgressFilteringService(allowedUrls);
  }, [permissionType, egress]);
};